<div id="slider">
    <figure *ngFor="let b of banner">
        <div class="banner_slider">
            <img src="{{ b.image }}" alt="slider-1">
            <h6>{{ b.title }}</h6>
            <p>{{ b.description }}</p>
        </div>
    </figure>
</div>